import styled, { css } from 'styled-components';

import CheckBox from '../../../CheckBox';
import { Sizes } from '../../../CheckBox/enums';
import Switcher from '../../../Switcher';
import { Sizes as SwitcherSizes } from '../../../Switcher/enums';

export const StyledCheckBox = styled(CheckBox)`
  ${({ size }) => {
    switch (size) {
      case Sizes.small:
        return css``;
      case Sizes.medium:
        return css`
          padding: 6px 0;
        `;
      default:
        return css`
          padding: 6px 0;
        `;
    }
  }}
  &:not(:last-child) {
    ${({ size }) => {
      switch (size) {
        case Sizes.small:
          return css`
            margin-bottom: 16px;
          `;
        case Sizes.medium:
          return css`
            margin-bottom: 24px;
          `;
        default:
          return css`
            margin-bottom: 24px;
          `;
      }
    }}
  }
`;
export const StyledSwitcher = styled(Switcher)`
  ${({ size }) => {
    switch (size) {
      case SwitcherSizes.small:
        return css``;
      case SwitcherSizes.medium:
        return css`
          padding: 2px 0;
        `;
      default:
        return css`
          padding: 2px 0;
        `;
    }
  }}
  &:not(:last-child) {
    ${({ size }) => {
      switch (size) {
        case SwitcherSizes.small:
          return css`
            margin-bottom: 16px;
          `;
        case SwitcherSizes.medium:
          return css`
            margin-bottom: 24px;
          `;
        default:
          return css`
            margin-bottom: 24px;
          `;
      }
    }}
  }
`;
